import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import api from "lib/api";
import * as microsoftTeams from "@microsoft/teams-js";
import DateTime from "_class/DateTime";
import User from "_class/User";
import { createAssessments, updateAssessment, getAssignmentAssessment, updateAssessmentStatus } from "actions/assessments";
import { createAssessmentBlock, updateAssessmentBlock, getBlocksByReference, clearBlocksOnReference, deleteBlock } from 'actions/blocks';
import { addError } from "actions";
import { getMicrosoftAssignmentDetails, getAssignmentSection, updateBulkAssignmentObject } from "actions/assignments";
import { setPageActions, setPageTitle } from "actions/header";
import { getTeamChannels } from "actions/sections";
import { getReaderParameters } from "actions/user";
import { trackImmersiveReaderError } from "helpers/insights";
import { getDescription } from "helpers/content";
import { generateMicrosoftAssignmentDeepLink } from "helpers/teams";
import { getRootUrl } from "helpers/url";
import Message from "../Partials/Message";
import Bookmark from '../Partials/Bookmark';
import AssessmentsConsumer from 'components/BlockAssessments/Consumer';
import SimpleSelect from "components/Inputs/SimpleSelect";
import PostContent from "components/Presentation/PostContent";
import KnowledgeRequirements from "containers/Forms/AssignmentForm/KnowledgeRequirements";
import Modal from "containers/Modals/Modal";
import { DataList, Skeleton } from "UI";
import RowItem, { RowCell } from "UI/Elements/List/RowItem";
import { Immersive_Reader } from "UI/Icons";
import { Block as ContentBlock, Button, translate } from "@haldor/ui";
import AssessmentForm from "containers/Forms/AssessmentForm";

var ImmersiveReader = require("@microsoft/immersive-reader-sdk");

var MicrosoftAssignment = /*#__PURE__*/function (_Component) {
  _inherits(MicrosoftAssignment, _Component);

  var _super = _createSuper(MicrosoftAssignment);

  function MicrosoftAssignment(props) {
    var _this;

    _classCallCheck(this, MicrosoftAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onFormToggle", function () {
      _this.setState({
        formModal: !_this.state.formModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFormSubmit", function (values) {
      var assignmentId = _this.props.assignment.id;

      if (_this.props.assignment.externalID != null) {
        //Assignment might be deleted in Teams. We need to fetch by Haldor Assignment Object Type
        assignmentId = _this.props.assignment.externalID;
      }

      return new Promise(function (resolve) {
        var startDate = _this.props.assignment.assignedDateTime;
        var assessmentBlocks = [];
        var deletedBlocks = [];

        if (startDate == null) {
          startDate = _this.props.assignment.assignDateTime;
        }

        if (values.assessmentBlocks != null) {
          assessmentBlocks = _toConsumableArray(values.assessmentBlocks);
        }

        if (_this.props.blocks) {
          deletedBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
            return !values.assessmentBlocks.find(function (_bl) {
              return _bl.id == block.id;
            });
          });
        }

        values.startDate = startDate;
        delete values.assessmentBlocks; // PUT the values here

        api.put("assignments", values).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var promises;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  promises = [];
                  _context2.next = 3;
                  return _this.props.getMicrosoftAssignmentDetails(assignmentId);

                case 3:
                  if (_this.props.details != null) {
                    assessmentBlocks.forEach(function (block) {
                      promises.push(new Promise( /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                          var _this$props$blocks;

                          var initialBlock;
                          return _regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  initialBlock = (_this$props$blocks = _this.props.blocks) === null || _this$props$blocks === void 0 ? void 0 : _this$props$blocks.find(function (b) {
                                    return b.id == block.id;
                                  });

                                  if (!(initialBlock != null)) {
                                    _context.next = 6;
                                    break;
                                  }

                                  _context.next = 4;
                                  return _this.props.updateAssessmentBlock(block, initialBlock);

                                case 4:
                                  _context.next = 8;
                                  break;

                                case 6:
                                  _context.next = 8;
                                  return _this.props.createAssessmentBlock(block, _this.props.details.id, 'ASSIGNMENT');

                                case 8:
                                  resolve(1);

                                case 9:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }));

                        return function (_x) {
                          return _ref2.apply(this, arguments);
                        };
                      }()));
                    });
                  }

                  if (deletedBlocks.length > 0) {
                    deletedBlocks.forEach(function (block) {
                      var deletePromise = new Promise(function (resolve) {
                        _this.props.deleteBlock(block.id).then(function () {
                          resolve(1);
                        });
                      });
                      promises.push(deletePromise);
                    });
                  }

                  _context2.next = 7;
                  return Promise.all(promises);

                case 7:
                  _this.props.updateBulkAssignmentObject(assignmentId, true);

                  _this.onFormToggle();

                  resolve(1);

                  if (_this.props.details != null) {
                    _this.props.getBlocksByReference(_this.props.details.id, 'ASSIGNMENT');
                  }

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, assignment, currentUser, localLanguage, data, reader;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, assignment = _this$props.assignment, currentUser = _this$props.currentUser;
              localLanguage = localStorage.getItem("language");
              data = {
                title: assignment.displayName,
                chunks: [{
                  content: "<h1>" + assignment.displayName + "</h1>",
                  mimeType: "text/html"
                }, {
                  content: getDescription(assignment.instructions.content),
                  mimeType: "text/html"
                }]
              };
              _context3.next = 5;
              return _this.props.getReaderParameters();

            case 5:
              reader = _this.props.reader;
              ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu

              })["catch"](function (error) {
                trackImmersiveReaderError(error, currentUser.id);
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      ImmersiveReader.close();
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", function () {
      var group = _this.props.groups.find(function (group) {
        return group.graphId == _this.props.assignment.classId;
      });

      var groupId = 0;
      var assignmentId = _this.props.assignment.id;

      if (group != null) {
        groupId = group.id;

        _this.props.getAssignmentSection(group.id);
      } else {
        if (_this.props.assignment.sectionId != null) {
          groupId = _this.props.assignment.sectionId;

          _this.props.getAssignmentSection(_this.props.assignment.sectionId);
        }
      }

      if (_this.props.assignment.externalID != null) {
        //Assignment might be deleted in Teams. We need to fetch by Haldor Assignment Object Type
        assignmentId = _this.props.assignment.externalID;
      }

      _this.setState({
        groupId: groupId,
        loadingAssessments: true
      });

      _this.props.getMicrosoftAssignmentDetails(assignmentId).then(function () {
        if (_this.props.details != null) {
          _this.setActions();

          _this.props.getBlocksByReference(_this.props.details.id, 'ASSIGNMENT');

          _this.props.getAssignmentAssessment(_this.props.details.id).then(function () {
            _this.setState({
              loadingAssessments: false,
              loadingDetails: false
            });
          });
        } else {
          _this.setState({
            loadingAssessments: false,
            loadingDetails: false
          });
        }
      });

      _this.setActions();
    });

    _defineProperty(_assertThisInitialized(_this), "setActions", function () {
      var currentUser = new User(_this.props.currentUser);

      if (_this.props.assignment != null) {
        if (_this.props.assignment.displayName != null) {
          _this.props.setPageTitle(_this.props.assignment.displayName);
        } else if (_this.props.assignment.title != null) {
          _this.props.setPageTitle(_this.props.assignment.title);
        }

        var actions = [];

        if (!currentUser.isStudent() && _this.props.services.microsoft && _this.props.details != null && _this.props.assignment.status != "ASSIGNMENT_DELETED") {
          actions.push({
            type: "button",
            onClick: _this.onFormToggle,
            value: _this.props.translate("edit-knowledge-requirements")
          });
        }

        if (_this.isFrame()) {
          microsoftTeams.app.getContext().then(function (context) {
            if (context.team) {
              actions.push({
                type: "button",
                value: _this.props.translate("open-workspace"),
                onClick: _this.onTeamsClick
              });

              _this.props.setPageActions(actions);
            } else {
              _this.props.getTeamChannels(_this.props.assignment.classId).then(function () {
                var generalChannel = _this.props.teamChannels.find(function (t) {
                  return t.displayName == "General";
                });

                if (generalChannel != null) {
                  _this.setState({
                    generalChannel: generalChannel
                  });

                  actions.push({
                    type: "button",
                    value: _this.props.translate("open-workspace"),
                    onClick: _this.onTeamsClick
                  });
                }

                _this.props.setPageActions(actions);
              });
            }
          });
        } else {
          _this.props.setPageActions(actions);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTeamsClick", function (e) {
      var assignment = _this.props.assignment;
      microsoftTeams.app.getContext().then(function (context) {
        var groupId = context.team.groupId;
        var channelId = context.channel.id;

        if (_this.state.generalChannel != null) {
          channelId = _this.state.generalChannel.id;
          groupId = _this.props.assignment.classId;
        }

        var link = generateMicrosoftAssignmentDeepLink(assignment.id, groupId, channelId);
        microsoftTeams.app.openLink(link);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAssessment", function () {
      _this.setState({
        assessmentOpen: false,
        loadingDetails: true
      }, function () {
        _this.loadData();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentSubmit", function (values) {
      return new Promise(function (resolve) {
        var students = _this.filterStudentList();

        values.externalId = _this.props.details.externalID;

        if (values.id != null) {
          var existing = _this.props.assessments.find(function (assessment) {
            return assessment.id == values.id;
          });

          _this.props.updateAssessment(values, existing).then(function () {
            resolve(1);

            _this.closeAssessment();
          });

          return true;
        }

        var selectedUsers = students.filter(function (t) {
          return t.selected;
        });
        var data = [];
        selectedUsers.forEach(function (user) {
          data.push(_objectSpread(_objectSpread({}, values), {}, {
            studentId: user.id
          }));
        });

        _this.props.createAssessments(data).then(function () {
          resolve(1);

          _this.closeAssessment();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssessmentStatusSelect", function (item, value) {
      var assessment = _this.props.assessments.find(function (t) {
        return t.studentId == item.id;
      });

      if (assessment != null) {
        _this.props.updateAssessmentStatus(assessment.id, value.value).then(function () {
          _this.props.addError(_this.props.translate("changes-saved"), "info");
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRow", function (student) {
      var _this$props2 = _this.props,
          assignment = _this$props2.assignment,
          translate = _this$props2.translate;
      var user = new User(student);

      var assessment = _this.props.assessments.find(function (t) {
        return t.studentId == student.id;
      });

      var submission = _this.props.assignment.submissions.find(function (t) {
        return t.recipient.userId == student.id;
      });

      var assignmentId = assignment.id;

      if (assignment.externalID != null) {
        //Assignment might be deleted in Teams. We need to fetch by Haldor Assignment Object Type
        assignmentId = assignment.externalID;
      }

      return /*#__PURE__*/React.createElement(RowItem, {
        key: student.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate("name")
      }, user.getName()), submission != null ? /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: _this.props.translate("status")
      }, translate("microsoft-assignment-" + submission.status)) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate("assessment-status")
      }, submission != null && (submission.status == "submitted" || submission.status == "returned" || submission.status == "reassigned") && assessment != null && !_this.state.loadingAssessments ? /*#__PURE__*/React.createElement(SimpleSelect, {
        selectedValue: assessment.status,
        name: "assessment-status",
        item: student,
        type: "assessment",
        onChange: _this.onAssessmentStatusSelect
      }) : null) : null, /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: " "
      }, submission != null ? /*#__PURE__*/React.createElement(Link, {
        to: "".concat(getRootUrl(), "assignment/").concat(assignmentId, "/submission/").concat(submission.id, "/documents")
      }, translate("view-files")) : null), !user.isStudent() ? /*#__PURE__*/React.createElement(RowCell, {
        shrink: true,
        title: translate("assess")
      }, submission != null && (submission.status == "submitted" || submission.status == "returned" || submission.status == "reassigned") ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          student.selected = true;

          _this.setState({
            assessmentOpen: true
          });
        },
        type: "secondary"
      }, translate("assess")) : /*#__PURE__*/React.createElement("span", null)) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "filterStudentList", function () {
      var _this$props3 = _this.props,
          group = _this$props3.group,
          assignment = _this$props3.assignment;
      var currentUser = new User(_this.props.currentUser);
      var students = [];

      if (assignment == null) {
        return;
      }

      if (assignment.submissions != null && assignment.submissions.length > 0) {
        if (group != null && currentUser.isTeacher()) {
          group.students.forEach(function (groupStudent) {
            var student = assignment.submissions.find(function (submission) {
              return submission.recipient.userId == groupStudent.id;
            });

            if (student != null) {
              students.push(groupStudent);
            }
          });
        }

        return students.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        });
      }

      if (assignment.assignTo == null || assignment.assignTo.recipients == null) {
        return;
      }

      if (group != null && currentUser.isTeacher()) {
        group.students.forEach(function (groupStudent) {
          if (_this.props.assignment.assignTo == null || _this.props.assignment.assignTo.recipients == null) {
            return;
          }

          var student = _this.props.assignment.assignTo.recipients.find(function (assignmentStudentId) {
            return assignmentStudentId == groupStudent.id;
          });

          if (student != null) {
            students.push(groupStudent);
          }
        });
      }

      return students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderDescription", function (assignment) {
      if (assignment.instructions != null) {
        return assignment.instructions.content;
      } else if (assignment.description != null) {
        return assignment.description;
      }

      return "";
    });

    _defineProperty(_assertThisInitialized(_this), "renderDate", function (assignment) {
      if (assignment.assignDateTime != null) {
        return /*#__PURE__*/React.createElement("div", null, new DateTime(assignment.assignDateTime).getShortDate(true));
      } else if (assignment.assignedDateTime != null) {
        return /*#__PURE__*/React.createElement("div", null, new DateTime(assignment.assignedDateTime).getShortDate(true));
      } else if (assignment.startDate != null) {
        return /*#__PURE__*/React.createElement("div", null, new DateTime(assignment.startDate).getShortDate(true));
      }

      return "";
    });

    _defineProperty(_assertThisInitialized(_this), "renderDueDate", function (assignment) {
      if (assignment.dueDateTime != null) {
        return new DateTime(assignment.dueDateTime).getShortDate(true);
      } else if (assignment.dueDate != null) {
        return new DateTime(assignment.dueDate).getShortDate(true);
      }

      return "";
    });

    _this.state = {
      groupId: null,
      assessmentOpen: false,
      formModal: false,
      loadingDetails: true,
      loadingAssessments: false
    };
    return _this;
  }

  _createClass(MicrosoftAssignment, [{
    key: "isFrame",
    value: function isFrame() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "renderModals",
    value: function renderModals(students) {
      if (this.state.loadingDetails) {
        return null;
      }

      var student = students === null || students === void 0 ? void 0 : students.find(function (student) {
        return student.selected;
      });

      if (student == null) {
        return null;
      }

      var assessment = this.props.assessments.find(function (t) {
        return t.studentId == student.id;
      });
      var assessmentBlocks = [];

      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.assessmentOpen,
        onClose: this.closeAssessment,
        title: this.props.translate("assessment")
      }, /*#__PURE__*/React.createElement(AssessmentForm, {
        onClose: this.closeAssessment,
        onSubmit: this.onAssessmentSubmit,
        blocks: assessmentBlocks,
        initialValues: assessment,
        items: [student].map(function (student) {
          return _objectSpread({
            firstname: student.firstName,
            lastname: student.lastName
          }, student);
        }),
        referenceId: this.props.details.id,
        referenceType: "TeamsAssignment",
        section: this.props.group
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          assignment = _this$props4.assignment,
          translate = _this$props4.translate,
          group = _this$props4.group;
      var currentUser = new User(this.props.currentUser);
      var description = this.renderDescription(assignment);
      var assessment = null;
      var assessmentBlocks = [];
      var students = this.filterStudentList();

      if (this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(this.props.blocks).filter(function (block) {
          return block.type == 'Haldor.Blocks.AssessmentBlock' && block.resources.length > 0;
        });
      }

      if (currentUser.isStudent() && this.props.assessments.length > 0) {
        assessment = this.props.assessments[0];
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-task"
      }, this.renderModals(students), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.formModal,
        title: translate("connect-knowledge-requirements"),
        onClose: this.onFormToggle
      }, /*#__PURE__*/React.createElement(KnowledgeRequirements, {
        group: group,
        onSubmit: this.onFormSubmit
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, !this.state.loadingDetails ? /*#__PURE__*/React.createElement(ContentBlock, null, description != '' ? /*#__PURE__*/React.createElement("div", null, this.props.services.immersiveReaderAssignments ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), this.props.translate("immersive-reader"))) : null, this.props.details != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Bookmark, {
        referenceType: "ASSIGNMENT",
        referenceId: this.props.details.id
      })) : null, /*#__PURE__*/React.createElement(PostContent, null, description)) : null, assignment.status == "ASSIGNMENT_DELETED" ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'red',
          fontWeight: 'bold'
        }
      }, this.props.translate('teams-assignment-deleted'))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate("start")), this.renderDate(assignment)), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate("end")), /*#__PURE__*/React.createElement("div", null, this.renderDueDate(assignment))), group != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate("section")), group.title) : null) : /*#__PURE__*/React.createElement(Skeleton, null), currentUser.isStudent() && this.props.services.conversations ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Message, {
        assignment: assignment
      })) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), assessmentBlocks.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment,
        isStudent: currentUser.isStudent()
      })) : null, currentUser.isTeacher() && !this.state.loadingDetails ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate("students"),
        data: group != null ? students : [],
        renderRow: this.renderStudentRow
      })) : null);
    }
  }]);

  return MicrosoftAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    blocks: state.Blocks.reference,
    services: state.Services.availableServices,
    group: state.assignments.section,
    groups: state.sections.educationGroups,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    assessments: state.assessments.assessments,
    details: state.assignments.teamsAssignmentDetails,
    reader: state.user.reader,
    teamChannels: state.sections.teamChannels
  };
}

export default connect(mapStateToProps, {
  getAssignmentSection: getAssignmentSection,
  getMicrosoftAssignmentDetails: getMicrosoftAssignmentDetails,
  getAssignmentAssessment: getAssignmentAssessment,
  addError: addError,
  updateAssessmentStatus: updateAssessmentStatus,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getReaderParameters: getReaderParameters,
  getTeamChannels: getTeamChannels,
  createAssessments: createAssessments,
  updateAssessment: updateAssessment,
  getBlocksByReference: getBlocksByReference,
  clearBlocksOnReference: clearBlocksOnReference,
  createAssessmentBlock: createAssessmentBlock,
  updateAssessmentBlock: updateAssessmentBlock,
  deleteBlock: deleteBlock,
  updateBulkAssignmentObject: updateBulkAssignmentObject
})(MicrosoftAssignment);